import { getBetType } from '../../../utils/bets';
import type { BetType } from '../bets/types';
import { ChipTypes } from '../chips/types';

/**
 * Returns the correct toast key for autoplay stop, based on free bet and campaign state.
 */
export function getAutoplayStopToastKey(isBonusCampaignActive: boolean, isFreeBet: boolean): string {
  return isFreeBet && !isBonusCampaignActive ? 'PROMO_FREE_CHIPS_BONUS_CONCLUDED' : 'AUTOPLAY_SUPPORT_CURR_BAL';
}

/**
 * Returns the casino balance or free chip balance based on the current bet and last bet
 */
export const getBalanceToUse = (
  currentBet: BetType | undefined,
  lastBet: BetType | null,
  casinoBalance: number,
  freeChipBalance: number
): number => {
  const bet = currentBet ?? lastBet;
  const betType = getBetType(bet);

  return betType === ChipTypes.FreeChip ? freeChipBalance : casinoBalance;
};
